export default "__VITE_ASSET__ov0yYmVJ__"